import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type ResponseGetClientsList = {
  id: string;
  userName: string;
  smerIds: string[];
  daybooksIds: string[];
  viewed: string[];
  shareWithPsySmer: boolean;
  shareWithPsyDaybook: boolean;
}[];

export const getClientsList = async () => {
  const response = await axios.get(`${rootUrl}/psychologist/clients/list`, {
    params: {
      token: getCookies('auth'),
    },
    headers: {
      'Cache-Control': 'no-store',
    },
  });

  return response.data;
};
